import { getPortalHttp } from '@/utils/http/portalHttp';
import type { GetChargeRulesApi, ScoreRechargeApi } from './types'
export const scoreRechargeApi = {
  /**
   * 获取积分充值数据
   * @description 获取数字人和积分的充值选项及相关配置
   * @returns 包含数字人充值选项、积分充值选项及相关配置的数据
   */
  reqGetScoreRecharge: () => {
    return getPortalHttp().get<ScoreRechargeApi.Result>('score-recharge/list')
  },
  /**
   * 获取计费规则,结果是数组[{label:'',desc:''},{}]
   * @returns 计费规则
   */
  reqGetChargeRules: () => {
    return getPortalHttp().get<GetChargeRulesApi.Result>('score-recharge/price')
  }
}
